ixModuleRouting("impactx.approvalincomplete", {
    "/incompleteapprovallist": {
        template: "<ixa-approval-incomplete-list></ixa-approval-incomplete-list>",
        process: "IncompleteApproval",
        workspace: "admin",
    },
    "/incompleteapproval/:id": {
        template: "<ixa-approval-incomplete></ixa-approval-incomplete>",
        process: "IncompleteApproval",
        workspace: "admin",
    },
});
